<template>
  <div>
    <Wechat v-if="type == 2 || type == 11" v-on:close="close" :type="type" :id="orderId" :amount="total_rate_amount" :order="order" :orderNo="orderNo"></Wechat>
    <OtherPayment v-if="(type == 3 || type == 12 || type==13) && type" v-on:close="close" :id="orderId" :type="type" :newWindow="newWindow" :order="order" :orderNo="orderNo"></OtherPayment>
  </div>
</template>

<script>
import Wechat from './Wechat'
import OtherPayment from './Other'
let _ = require('lodash')

export default {
  name: 'PaymentDialog',
  props: ['orderId', 'type', 'newWindow', 'order','orderNo'],
  components: {
    Wechat: Wechat,
    OtherPayment: OtherPayment
  },
  computed: {
  },
  data () {
    return {
      total_rate_amount: null
    }
  },
  created () {
    if(this.order.fee_adjustment_list.length>0){
      this.total_rate_amount = this.order.fee_adjustment_list[0].unpaid_fee_rmb
    }
    if(this.order.fee_adjustment_list.length==0){
      this.total_rate_amount = this.order.total_amount * this.order.conditions.rate
    }
    console.log(this.newWindow)
  },
  methods: {
    close () {
      this.$emit('close')
    }
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.payment-wechat-page {
  padding-bottom: 45px;
}
h1 {
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular;
  color:rgba(51,51,51,1);
  line-height:25px;
}
img {
  margin-top: 20px;
  border: 1px solid #DEE2EC;
  width: 220px;
  height: 220px;
}
.redirct {
  font-size:24px;
  font-family:PingFangSC-Regular;
  line-height:33px;
  margin-top: 54px;
  padding-bottom: 70px;

  a {
    font-size: 16px;
  }

  p {
    line-height: 24px;
    color: #888
  }
}
.primary-reverse {
  border-color: #0F66CF;
  color:#0F66CF;
  &:hover {
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/PaymentTip.vue